import React from 'react'
import s from '../css/header.module.css'
import { Link } from 'react-router-dom'

const Header = ({ toggleHeader, isHeaderOpen, isAuth, signOutFunc }) => {
	return (
		<header className={`${s.tag} ${isHeaderOpen ? s.open : ''}`}>
			<div className={s.body}>
				<div className={s.burger} onClick={toggleHeader}>
					<span></span>
					<span></span>
					<span></span>
				</div>
				<div className={s.logo}>
					<Link to='/' tabIndex='1'>
						Kinopoisk Api Unofficial
					</Link>
				</div>
				<nav className={s.menu}>
					<ul>
						<li>
							<a
								tabIndex='2'
								href='https://kinopoiskapiunofficial.tech/documentation/api/'
								target='_blank'
								rel='noreferrer'
							>
								Документация
							</a>
						</li>
						<li>
							<Link to='/changes' tabIndex='3'>
								Изменения
							</Link>
						</li>
						<li>
							<Link to='/status' tabIndex='4'>
								Статус
							</Link>
						</li>
						{isAuth ? (
							<li>
								<Link to='/profile' tabIndex='5'>
									Профиль
								</Link>
							</li>
						) : (
							''
						)}
					</ul>
				</nav>

				<div className={s.auth}>
					<ul>
						{isAuth ? (
							''
						) : (
							<>
								<li className={s.signin}>
									<Link to='/signin' tabIndex='6'>
										Войти
									</Link>
								</li>
								<li className={s.signup}>
									<Link to='/signup' tabIndex='7'>
										Зарегистрироваться
									</Link>
								</li>
							</>
						)}

						{isAuth ? (
							<li className={s.signout}>
								<a href='!#' tabIndex='7' onClick={e => signOutFunc(e)}>
									Выйти
								</a>
							</li>
						) : (
							''
						)}
					</ul>
				</div>
			</div>
			<div className={s.overlay} onClick={toggleHeader}></div>
		</header>
	)
}

export default Header
